import React from 'react';
import mapJson from 'jsonpath-mapper';
import { useSelector } from 'react-redux';
import { PanelTypes } from '@/types/Panel.types';
import BlocksPanel from '@/components/panels/blocksPanel/BlocksPanel';
import LoginPanel from '@/components/panels/loginPanel/LoginPanel';
import LogoutPanel from '@/components/panels/logoutPanel/LogoutPanel';
import PersonalizationPanel from '@/components/panels/personalizationPanel/PersonalizationPanel';
import PositionPanel from '@/components/panels/positionPanel/PositonPanel';
import SharePanel from '@/components/panels/sharePanel/SharePanel';
import VersionStatusPanel from '@/components/panels/versionStatusPanel/VersionStatusPanel';
import VersionsPanel from '@/components/panels/versionsPanel/VersionsPanel';
import { BlocksPanelMappings } from '@/components/toolbar/Toolbar.mapper';
import {
  getBlocksError,
  getBlocksLoading,
  getBlocksPayload,
  getSelectedBlock,
} from '@/redux/selectors/app';

const Panel = ({
  setPanel,
  panel,
}: {
  setPanel: (v: PanelTypes | '') => void;
  panel: PanelTypes | '';
}) => {
  const block = useSelector(getSelectedBlock);
  const loading = useSelector(getBlocksLoading);
  const error = useSelector(getBlocksError);
  const blocks = useSelector(getBlocksPayload);
  const onClose = () => setPanel('');

  if (panel === PanelTypes.Blocks) {
    return (
      <BlocksPanel
        {...mapJson({ blocks }, BlocksPanelMappings)}
        setPanel={setPanel}
        onClose={onClose}
        loading={loading}
        error={error}
      />
    );
  }

  if (panel === PanelTypes.Personalization) {
    return <PersonalizationPanel title="Personalization" onClose={onClose} />;
  }

  if (panel === PanelTypes.Version) {
    return (
      <VersionsPanel
        {...block}
        onClose={onClose}
        onBack={() => setPanel(PanelTypes.Blocks)}
      />
    );
  }

  if (panel === PanelTypes.VersionStatus) {
    return <VersionStatusPanel onClose={onClose} />;
  }

  if (panel === PanelTypes.Share) {
    return <SharePanel onClose={onClose} />;
  }

  if (panel === PanelTypes.Position) {
    return <PositionPanel onClose={onClose} />;
  }

  if (panel === PanelTypes.Logout) {
    return <LogoutPanel onClose={onClose} />;
  }

  if (panel === PanelTypes.Login) {
    return <LoginPanel />;
  } else return <></>;
};

export default Panel;
